<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                <strong>{{$t('sidebars.productCardex')}}</strong>
                            </CCol>
                            <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                                <CButton @click="get_lists" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                            </CCol>

                        </CRow>
                    </CCardHeader>
                    <br>
                    <CRow>
                        <CCol col="12">
                            <CRow>
                                <CCol col="3">
                                    <treeselect
                                            v-model="selected_product"

                                            :normalizer="normalizer_products"
                                            :async="async_product_search"
                                            @select="select_product"
                                            :options="models"
                                            :loadOptions="load_products"
                                            :placeholder="$t('components.searchProduct')"
                                    />
                                </CCol>
                                <CCol col="2">
                                    <select v-model="selected_place" class="form-control"

                                    >
                                        <option value="0">
                                            {{ $t('components.selectWarehouse') }}
                                        </option>
                                        <option v-for="option in places_items" v-bind:value="option.id">
                                            {{ option.placeName }}
                                        </option>
                                    </select>
                                </CCol>
                                <CCol col="2">
                                    <select v-model="selected_type" class="form-control"

                                    >
                                        <option value="0">
                                            {{ $t('all') }}
                                        </option>
                                        <option value="1">
                                            {{ $t('output') }}
                                        </option>
                                        <option value="2">
                                            {{ $t('input') }}
                                        </option>

                                    </select>
                                </CCol>
                                <CCol>
                                    <date-picker
                                            :label="$t('components.startDate')"
                                            v-model="start_date"></date-picker>
                                </CCol>
                                <CCol>
                                    <date-picker
                                            :label="$t('components.endDate')"
                                            v-model="end_date"></date-picker>
                                </CCol>
                            </CRow>
                        </CCol>

                        <CCol>
                            <CCard class="p-1">
                                <CRow v-if="items_customer.length">
                                    <!--                          <CCol col="2">-->
                                    <!--                            {{ $t('Quantity') }}-->
                                    <!--                          </CCol>-->
                                    <!--                          <CCol col="3">-->
                                    <!--                            {{ $t('TotalExistence') }}: {{ total_existance }}-->
                                    <!--                          </CCol>-->
                                    <!--                          <CCol col="3">-->
                                    <!--                            {{ $t('InventoryExistence') }}: {{ total_existance }}-->
                                    <!--                          </CCol>-->
                                    <CCol col="3" style="font-weight: bold">
                                        {{ $t('INVValuation') }}: {{ exitType }}
                                    </CCol>
                                    <CCol col="3" style="direction: ltr;font-weight: bold">
                                        {{ $t('components.unitPrice') }}: {{ currency_symbol()
                                        }}{{get_currency(unit_price)}}
                                    </CCol>
                                    <CCol col="3" style="direction: ltr;font-weight: bold">
                                        {{ $t('components.existence') }}: {{ get_currency_no_fix(parseInt((get_sum_existance(items_customer.filter(x=>x.sumExistance>0))+
                                        parseInt(items_customer[0].orginalExistance) +
                                        get_sum_existance(items_customer.filter(x=>x.sumExistance<0)))/product_unit_value)) }}
                                    </CCol>

                                </CRow>
                                <CRow>
                                    <!--                          <CCol col="2">-->
                                    <!--                            {{ $t('tables.amount') }} {{currency_symbol()}}-->
                                    <!--                          </CCol>-->
                                    <!--                          <CCol col="3">-->
                                    <!--                            {{ $t('TotalExistence') }}: {{ total_existance }}-->

                                    <!--                          </CCol>-->
                                    <!--                          <CCol col="3">-->
                                    <!--                            {{ $t('InventoryExistence') }}: {{ total_existance }}-->
                                    <!--                          </CCol>-->


                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <input-tag v-model="selected_locations" :allow-duplicates="false"
                                                   style="min-height: 30px" :read-only="false"></input-tag>
                                    </CCol>
                                </CRow>

                            </CCard>
                        </CCol>
                    </CRow>

                    <!--                  <CRow>-->
                    <!--                        <CCol>-->
                    <!--                            <date-picker-->
                    <!--                                    :label="$t('components.startDate')"-->
                    <!--                                    v-model="start_date"></date-picker>-->
                    <!--                        </CCol>-->
                    <!--                        <CCol>-->
                    <!--                            <date-picker-->
                    <!--                                    :label="$t('components.endDate')"-->
                    <!--                                    v-model="end_date"></date-picker>-->
                    <!--                        </CCol>-->
                    <!--                        <CCol>-->
                    <!--                            <CSelect-->
                    <!--                                :label="$t('tables.type')"-->
                    <!--                                    horizontal-->
                    <!--                                    :value.sync="selected_type_parent"-->
                    <!--                                    :options="types_parent"-->
                    <!--                            />-->
                    <!--                        </CCol>-->
                    <!--                        <CCol v-if="get_child_options().length>1">-->
                    <!--                            <CSelect-->
                    <!--                                    horizontal-->
                    <!--                                    :value.sync="selected_type_child"-->
                    <!--                                    :options="get_child_options()"-->
                    <!--                            />-->
                    <!--                        </CCol>-->


                    <!--                        <CCol >-->
                    <!--                            <treeselect-->
                    <!--                                    v-model="selected_product"-->
                    <!---->
                    <!--                                    :normalizer="normalizer_products"-->
                    <!--                                    :async="true"-->
                    <!--                                    :loadOptions="load_products"-->
                    <!--                                    :placeholder="$t('components.searchProduct')"-->
                    <!--                            />-->
                    <!--                        </CCol>-->


                    <!--                    </CRow>-->
                    <CCardBody class="mb-3">
                        <CDataTableFixed
                                :items="items_customer_filtered"
                                :fields="fields"
                                height="250px"
                                :items-per-page="20"
                                hover
                                border
                                striped
                        >
                            <template #row_id="{item,index}">
                                <td :style="get_style(item)">
                                    <p style="text-align: center">{{ index+1 }}</p>
                                </td>
                            </template>
                            <template #docTypeTitle="{item}">
                                <td  :style="get_style(item)">
                                    <p style="text-align: center">{{ item.docTypeTitle }}</p>
                                </td>
                            </template>

                            <template #amount="{item}">
                                <td  :style="get_style(item)">
                                    <p>{{ item.amount }}</p>
                                </td>
                            </template>
                            <template #docDate="{item}">
                                <td  :style="get_style(item)">
                                    <p v-if="item.recId!=0" style="text-align: center">{{ get_date(item.docDate) }}</p>
                                </td>
                            </template>
                            <template #amountNegetive="{item}">
                                <td  :style="get_style(item)">
                                    <p>{{ item.amountNegetive }}</p>
                                </td>
                            </template>
                            <template #accBalance="{item}">
                                <td  :style="get_style(item)">
                                    <p>{{ item.accBalance }}</p>
                                </td>
                            </template>
                            <template #accBalanceNegetive="{item}">
                                <td  :style="get_style(item)">
                                    <p>{{ item.accBalanceNegetive }}</p>
                                </td>
                            </template>

                            <template #kardexAccTypeTitle="{item}">
                                <td  :style="get_style(item)">
                                    <strong>{{ item.kardexAccTypeTitle }}</strong>
                                </td>
                            </template>

                            <template #partyName="{item}">
                                <td  :style="get_style(item)">
                                    <p v-if="item.recId!=0">{{ item.partyCode }} {{ item.partyName }}</p>
                                    <p v-if="item.recId==0">{{$t('balanceBefore')}}</p>
                                </td>
                            </template>

                            <template #masterCode="{item}">
                                <td  :style="get_style(item)" class="text-center">
                                    <a  v-if="item.recId!=0" href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                                        {{ item.masterCode }}
                                    </a>
                                </td>
                            </template>

                            <template #summary="{item}">
                                <td  :style="get_style(item)">
                                    <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                                </td>

                            </template>

                            <template #operation="{item}">
                                <td  :style="get_style(item)">
                                    <CButton
                                            class="m-1"
                                            color="primary"
                                            variant="outline"
                                            square
                                            :title="$t('buttons.edit')"

                                            size="sm"
                                            @click="goEditPerson(item)"
                                    >
                                        <CIcon name="cil-pencil"/>
                                    </CButton>
                                    <CButton class="m-1"
                                             color="success"
                                             variant="outline"
                                             square
                                             size="sm"
                                             :title="$t('buttons.documents')"
                                             @click="goToDocuments(item)"
                                    >
                                        <CIcon name="cil-list-rich"/>
                                    </CButton>

                                </td>
                            </template>


                            <template #sumExistanceP="{item}">
                                <td  :style="get_style(item)">
                                    <p style="text-align: right" v-if="item.sumExistance>0">{{ get_currency(item.sumExistance) }}</p>
                                    <p style="text-align: right" v-else>{{ get_currency(0) }}</p>
                                </td>
                            </template>
                            <template #sumExistanceN="{item}">
                                <td  :style="get_style(item)">
                                    <p style="text-align: right" v-if="item.sumExistance<=0">{{
                                        get_currency(Math.abs(item.sumExistance)) }}</p>
                                    <p style="text-align: right" v-else>{{ get_currency(0) }}</p>

                                </td>
                            </template>
                            <template #sumAmountP="{item}">
                                <td  :style="get_style(item)">
                                    <p style="text-align: right" v-if="item.sumExistance>0">{{ get_currency(item.amount)
                                        }}</p>
                                    <p style="text-align: right" v-else>{{ get_currency(0) }}</p>

                                </td>
                            </template>

                            <template #sumAmountN="{item}">
                                <td  :style="get_style(item)">
                                    <p style="text-align: right" v-if="item.sumExistance<=0">{{
                                        get_currency(Math.abs(item.amount)) }}</p>
                                    <p style="text-align: right" v-else>{{ get_currency(0) }}</p>
                                </td>
                            </template>


                            <template #orginalExistance="{item}">
                                <td  :style="get_style(item)">
                                    <p style="text-align: right">{{get_currency(item.orginalExistance)}}</p>

                                </td>
                            </template>
                            <template #balanceAmount="{item}">
                                <td  :style="get_style(item)">
                                    <p style="text-align: right">{{get_currency(item.balanceAmount)}}</p>
                                </td>
                            </template>
                          <template #caption>
                            <tr class="total-table">
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>{{$t('totalCirculation')}}</td>
                              <td>
                                {{get_currency_no_fix(get_sum_existance(items_customer.filter(x=>x.sumExistance>0)))}}
                              </td>
                              <td>
                                {{currency_with_symbol(calculate_multipy_items(items_customer.filter(x=>x.sumExistance>0)))}}
                              </td>
                              <td>
                                {{get_currency_no_fix(Math.abs(get_sum_existance(items_customer.filter(x=>x.sumExistance<0))))}}
                              </td>
                              <td>    {{currency_with_symbol(calculate_multipy_items(items_customer.filter(x=>x.sumExistance<0)))}}
                              </td>
                              <td>
                                {{
                                  get_currency_no_fix(get_sum_existance(
                                      items_customer.filter(x=>x.sumExistance>0))
                                      +get_sum_existance(items_customer.filter(x=>x.sumExistance<0))
                                      + items_customer.filter(x=>x.recId==0)[0].orginalExistance)
                                }}
                              </td>
                              <td>
                                {{currency_with_symbol(
                                  calculate_multipy_items(items_customer.filter(x=>x.sumExistance>0))
                                  -
                                  calculate_multipy_items(items_customer.filter(x=>x.sumExistance<0))
                                  + items_customer.filter(x=>x.recId==0)[0].balanceAmount
                              )
                                }}
                              </td>
                            </tr>
                          </template>
<!--                            <template #under-table>-->
<!--                                <CRow >-->
<!--                                    <CCol></CCol>-->
<!--                                    <CCol></CCol>-->
<!--                                    <CCol></CCol>-->
<!--                                    <CCol></CCol>-->


<!--                                    <CCol  style="font-weight: bold">{{$t('totalCirculation')}}</CCol>-->
<!--                                    <CCol style="text-align: end;font-weight: bold">-->
<!--                                        {{get_currency_no_fix(get_sum_existance(items_customer.filter(x=>x.sumExistance>0)))}}-->
<!--                                    </CCol>-->
<!--                                    <CCol style="font-weight: bold">{{currency_with_symbol(calculate_multipy_items(items_customer.filter(x=>x.sumExistance>0)))}}</CCol>-->

<!--                                    <CCol style="text-align: end;font-weight: bold">-->
<!--                                        {{get_currency_no_fix(Math.abs(get_sum_existance(items_customer.filter(x=>x.sumExistance<0))))}}-->
<!--                                    </CCol>-->
<!--                                    <CCol style="font-weight: bold">-->
<!--                                        {{currency_with_symbol(calculate_multipy_items(items_customer.filter(x=>x.sumExistance<0)))}}-->
<!--                                    </CCol>-->
<!--                                    <CCol></CCol>-->
<!--                                    <CCol></CCol>-->
<!--                                </CRow>-->
<!--                                <CRow>-->
<!--                                    <CCol></CCol>-->
<!--                                    <CCol></CCol>-->
<!--                                    <CCol></CCol>-->
<!--                                    <CCol></CCol>-->

<!--                                    <CCol class="bg-dark"  style="font-weight: bold">{{$t('components.existence')}}</CCol>-->
<!--                                    <CCol class="bg-dark"  style="text-align: end;font-weight: bold">-->
<!--                                        {{-->
<!--                                        get_currency_no_fix(get_sum_existance(-->
<!--                                        items_customer.filter(x=>x.sumExistance>0))-->
<!--                                        +get_sum_existance(items_customer.filter(x=>x.sumExistance<0))-->
<!--                                        + items_customer.filter(x=>x.recId==0)[0].orginalExistance)-->
<!--                                        }}-->
<!--                                    </CCol>-->
<!--                                    <CCol class="bg-dark"></CCol>-->

<!--                                    <CCol class="bg-dark"></CCol>-->
<!--                                    <CCol class="bg-dark" style="font-weight: bold">-->
<!--                                        {{currency_with_symbol(-->
<!--                                        calculate_multipy_items(items_customer.filter(x=>x.sumExistance>0))-->
<!--                                        - -->
<!--                                        calculate_multipy_items(items_customer.filter(x=>x.sumExistance<0))-->
<!--                                        + items_customer.filter(x=>x.recId==0)[0].balanceAmount-->
<!--                                        )-->
<!--                                        }}-->
<!--                                    </CCol>-->
<!--                                    <CCol></CCol>-->
<!--                                    <CCol></CCol>-->
<!--                                </CRow>-->

<!--                            </template>-->

                        </CDataTableFixed>

                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Vue from "vue";
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    import ReportGrid from "../reports/ReportGrid";

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    export default {
        name: 'Login',
        components: {
            Treeselect,
            ReportGrid
        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                VUE_APP_Currency: localStorage.getItem('currency'),
                items_customer: [],
                items_customer_filtered: [],
                start_date: '',
                selected_type: 0,
                product_unit_value:1,
                types_all: [],
                types_parent: [],
                selected_type_parent: 0,
                selected_type_child: 0,
                selected_place: 0,
                places_items: [],

                end_date: '',
                fields: [
                    {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
                    {key: 'docDate', label: this.$t('date'), _style: 'width:8%'},
                    // {key: 'docNo', label: this.$t('docNumber'), _style: 'width:10%'},

                    // {key: 'docTypeTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
                    {key: 'masterCode', label: this.$t('ref'), _style: 'width:7%'},
                    {key: 'partyName', label: this.$t('supplier_customer'), _style: 'width:20%'},
                    // {key: 'partyName', label: this.$t('supplier_customer'), _style: 'width:10%'},

                    {key: 'sumExistanceP', label: this.$t('income_qty'), _style: 'width:10%'},
                    {key: 'sumAmountP', label: this.$t('inputUPrice'), _style: 'width:10%'},


                    {key: 'sumExistanceN', label: this.$t('outgoing_qty'), _style: 'width:10%'},
                    {key: 'sumAmountN', label: this.$t('outputUPrice'), _style: 'width:10%'},
                    {key: 'orginalExistance', label: this.$t('stockQty'), _style: 'width:10%'},
                    {key: 'balanceAmount', label: this.$t('stockAmt'), _style: 'width:10%'},

                    // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},

                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

                ],
                normalizer_accounting(node) {
                    return {
                        id: node.id,
                        label: node.accountCode + " " + node.accountName,
                    }
                },
                normalizer_accounting_tafzili(node) {
                    return {
                        id: node.recId,
                        label: node.title,
                    }
                },
                load_products({action, searchQuery, callback}) {
                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_products(node) {
                    return {
                        id: node.id,
                        label: node.productCodeName,

                    }
                },
                templates_items: [],
                accounting_list: [],
                moein_list: [],
                tafsili_list: [],
                selected_product: null,
                selected_moein: null,
                selected_tafsili: null,
                collapseDuration: 0,
                person_name: '',
                status_form: 0,
                unit_price: "0",
                exitType: "",
                async_product_search:true,
                models:[],
            }
        }, mounted() {

            this.$root.root_validate_errors = [];
            this.get_lists_groups();
            this.get_types();
            this.get_places();

            // this.get_lists();
            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
            if(this.$route.params.product_name!=null){
                var data = this.$route.params;
                this.async_product_search = false;

                this.models.push({productCodeName:data.product_name,id:data.productid})
                this.selected_product = data.productid
                this.start_date = data.start_date;
                this.end_date = data.end_date
                this.input_products=[{id: data.productid, productCodeName:data.product_name}]
                this.get_lists()
                setTimeout(() => {
                    this.async_product_search = true;

                }, 500);

            }
        }, watch: {
            'selected_tafsili': function () {
                // this.get_lists();
            },
            'selected_type': function () {
                if(this.selected_type==0){
                    this.items_customer_filtered = this.items_customer
                }
                if(this.selected_type==1){
                    this.items_customer_filtered = this.items_customer.filter(x=>x.sumExistance<=0)
                }

                if(this.selected_type==2){
                    this.items_customer_filtered = this.items_customer.filter(x=>x.sumExistance>0)
                }

            }
        },
        methods: {
            select_product(node){
                this.product_unit_value = node.value
            },
            calculate_multipy_items(list) {
                var total = 0;
                list.forEach(function (val) {
                    total += parseFloat(val.amount) * Math.abs(parseFloat(val.sumExistance))
                })
                return total
            },
            get_places() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetPlaces', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.places_items = content_data.data;


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_style(item) {
                var color = '#56ff42';
                if(item.recId==0){
                    // return 'backgroundColor: \'#56ff42\'';
                    return {

                        backgroundColor: color

                    }
                }

            },
            get_sum_existance(list) {
                var sum = 0;
                list.forEach((val) => {
                    sum += val.sumExistance;
                })
                return sum;
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.unitName;
                this.color = item.color;
                this.description = item.description;
                this.previewImage = item.image;
                this.status_form = item.id;
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            }, edit_sale_method(item) {
                this.selected_method = item.saleMethodId;
                this.selected_person = item.userId;
                this.saleMethodModal = true;

            },
            select_moein(node) {
                var self = this;

                const formData = new FormData();
                var url = "GetAccountTafsiliList";
                formData.append("id", node.id);

                // self.tafzili_list = [];

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            // item.tafzili_list = response.data.data;
                            self.tafsili_list = response.data.data
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                ).catch(function (error) {
                    console.log(error);
                });

            },
            get_lists_groups() {

                var self = this;
                self.items_parent = [];
                self.data_with_children = []

                const formData = new FormData();
                var url = "Get_AllAccountingGroups";

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            self.accounting_list = response.data.data
                            response.data.data.forEach((val) => {
                                if (val.parentId == 0) {

                                    self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                                        self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                                            self.moein_list.push(val3)

                                        });

                                    });

                                }

                            });
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_childrens_one_sub(parent_id, list) {
                var array = [];
                var self = this;
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
                        array.push(val2);


                    }
                });
                return array;
            },
            get_lists() {
                var self = this;
                //
                if (this.selected_product == null) {
                    this.$root.root_validate_errors.push(this.$t('selectOneProduct'));
                    return
                }

                const formData = new FormData();

                var url = "GetCurrentExistance";

                formData.append('FromDate', this.start_date);
                formData.append('ToDate', this.end_date);
                if(this.selected_product==null){
                    formData.append('ProductId', 0);

                }else{
                    formData.append('ProductId', this.selected_product);

                }
                formData.append('Place', this.selected_place);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_customer = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.get_unit_price();
                        self.items_customer.forEach(function (val,index) {
                            if(index!=0){
                                val.orginalExistance =self.items_customer[index-1].orginalExistance +  val.sumExistance
                                val.balanceAmount = self.items_customer[index-1].balanceAmount +(val.sumExistance* val.amount)
                            }else{
                              val.balanceAmount = val.bgInvAmt
                            }
                            if(val.sumExistance>0){
                                val.sumExistanceP= val.sumExistance
                                val.sumExistanceN= 0
                            }else{
                                val.sumExistanceN= val.sumExistance
                                val.sumExistanceP= 0
                            }
// val.orginalExistance = sumExistanceP
//             sumExistanceN
                        })

                        self.items_customer_filtered = self.items_customer
                        // self.templates_items = content_data.data;
                        // self.total_existance = self.items[0].orginalExistance
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_unit_price() {
                var self = this;
                //
                if (this.selected_product == null) {
                    this.$root.root_validate_errors.push(this.$t('selectOneProduct'));
                    return
                }

                const formData = new FormData();

                var url = "GetLastProductPrice";

                formData.append('Id', this.selected_product);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.unit_price = content_data.data.unitPrice;
                        self.exitType = content_data.data.exitType;
                        // self.templates_items = content_data.data;
                        // self.total_existance = self.items[0].orginalExistance
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goEditPerson(item) {

                this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

            },
            goToDocuments(item) {
                window.open("/dashboard/documents/show/" + item.masterId)
                // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

            },

            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.id;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeletePerson";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();

                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            get_types() {
                var self = this;


                const formData = new FormData();

                var url = "GetReportNumberList";

                // formData.append('id', "1532");
                //
                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        var data_get = self.sort_array([], content_data.data
                            , "id", "title");
                        self.types_all = data_get.filter(x => x.typeId == 2);
                        self.types_parent = data_get.filter(x => x.parentId == 0 && x.typeId == 2);
                        self.selected_type_parent = self.types_parent[0].value;
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_child_options() {
                var array = [{label: this.$t('select'), value: 0}];
                var newArray = array.concat(this.types_all.filter(x => x.parentId == this.selected_type_parent));
                return newArray
            }

        }
    }

</script>
